var EventEmitter = require('events').EventEmitter;
var AppDispatcher = require('../dispatcher/AppDispatcher');
var assign = require('object-assign');
var BaseStore = require('./BaseStore');

var CHANGE_EVENT = 'change';

var ModelStore = assign({}, BaseStore, {
	//getResourceById: function (id) {
	//	// http://stackoverflow.com/questions/12553274/getting-index-of-an-arrays-element-based-on-its-properties
	//	var index = _resourceListData.map(function(item) {
	//		return item.id
	//	}).indexOf(id);
	//
	//	return _resourceListData[index];
	//},

	reorderData: function () {
		// Reorder stuff
	}
});

module.exports = ModelStore;


